import request from 'utils/request'

// 获取列表数据
export const getTableData = data =>
  request().post('creditApproveEmail/page', data)

// 添加条件
export const add = data => request().post('creditApproveEmail/add', data)
